import { GetLinks } from "../../../config";

export default [
  {
    key: "/ads-360",
    icon: (
      <i className="ki-duotone ki-chart-pie-simple fs-1">
        <span className="path1" />
        <span className="path2" />
      </i>
    ),
    label: GetLinks("/ads-360", "Ads 360"),
  },
];
